import BaseComponent from './BaseComponent';

class Newsletter extends BaseComponent {
    constructor(el) {
        super(el);

        let form = el.querySelector('form');

        el.addEventListener('submit', (e) => {
            e.preventDefault();

            fetch(form.action, {
                method: 'POST',
                body: new URLSearchParams(new FormData(e.target)),
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(function (response) {
                    if (response.ok) {
                        return response.json();
                    }
                    return Promise.reject(response);
                })
                .then(function (data) {
                    form.innerHTML = '<p class="newsletter__text">' + data.message + '</p>';
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default Newsletter;
